import { render, staticRenderFns } from "./AdditionalMaterialCard.vue?vue&type=template&id=e8e734b2&scoped=true&"
import script from "./AdditionalMaterialCard.vue?vue&type=script&lang=js&"
export * from "./AdditionalMaterialCard.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalMaterialCard.vue?vue&type=style&index=0&id=e8e734b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e734b2",
  null
  
)

export default component.exports